export { default as NotesPane } from './components/NotesPane';
export { default as ChangeColorButton } from './components/ColorCommandBarButton';
export { default as createNewNote } from './actions/createNewNote';
export { default as deleteNote } from './actions/deleteNote';
export { default as changeNoteColor } from './actions/changeNoteColor';

// Import orchestrators
import './orchestrators/onLocaleChanged';
import './orchestrators/onThemeChanged';
